
export interface TableAction {
  icon?: string;
  iconPath?: string;
  action: string;
  title: string;
  type?: 'button' | 'checkbox';
  checkedField?: string;
  showText?: boolean;
  buttonColor?: 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'danger' | 'default';
  iconSize?: 'small' | 'medium' | 'large';
  condition?: (row: any) => boolean;
  preventToggleWhen?: (row: any) => boolean;
}

export interface TableColumn {
  field: string;
  header: string;
  type?: 'text' | 'link' | 'badge' | 'action' | 'date' | 'number' | 'linked-tender' | 'radio' | 'custom';
  linkRoute?: string;
  badgeClass?: string;
  badgeColor?: BadgeColor | ((row: any) => BadgeColor);
  badgeSize?: 'small' | 'medium' | 'large';
  format?: string;
  actionIcon?: string;
  actionTitle?: string;
  actions?: TableAction[];
  sortable?: boolean;
  showCurrentTag?: boolean;
  filterable?: boolean;
  radioGroupName?: string;
  isSelected?: (row: any) => boolean;
  onSelect?: (row: any, event: Event) => void;
  customTemplate?: (row: any) => string;
}

export type TextFilterOperator = 'equals' | 'doesNotEqual' | 'contains' | 'doesNotContain' | 'startsWith' | 'endsWith';
export type NumberFilterOperator = 'equals' | 'doesNotEqual' | 'greaterThan' | 'lessThan' | 'between';
export type DateFilterOperator = 'equals' | 'doesNotEqual' | 'before' | 'after' | 'between' | 'today' | 'thisWeek' | 'thisMonth';
export type SelectFilterOperator = 'isOneOf' | 'isNotOneOf';
export type FilterOperator = TextFilterOperator | NumberFilterOperator | DateFilterOperator | SelectFilterOperator;

export interface ColumnFilter {
  field: string;
  operator: FilterOperator;
  values: any[];
  sortDirection?: 'asc' | 'desc' | null;
}

export type SortDirection = 'asc' | 'desc' | null;

export interface SortOption {
  label: string;
  direction: SortDirection;
  icon: string;
}

export type BadgeColor = 'green' | 'blue' | 'pink' | 'gray' | 'yellow' | 'red' | 'orange' | 'purple';
interface HTMLInputEvent extends Event {
    target: HTMLInputElement & EventTarget;
}
export class FamilyMembers {
    name: string;
    qId: string;
    id: string;
    copyofId: {attachmentId: string; isModified: boolean}
}
export class LabelValue {
    labelEn: string;
    labelAr: string;
    value: number;
    cssClass: string;
    descEn: string;
    descAr: string;
    constructor({labelEn, labelAr, value, cssClass, descEn, descAr}: {labelEn?, labelAr?, value?, cssClass?, descEn?, descAr?} = {}) { 
        this.labelEn = labelEn;
        this.labelAr = labelAr;
        this.value = value;
        this.cssClass = cssClass;
        this.descAr = descAr;
        this.descEn = descEn;
    }
}

export class CountryMaster {
    countryName: string;     
    countryRegionId: string;  

}

export class Message {
    direction?: string;
    moudle?: string; // module, like general or bidding
    vendorID?: string;
    subReferenceNumber?: number;  // invoice number
    referenceNumber?: string | null; // e.g., bidding id, PO, null for general messages
    messageContent?: string;
    CreatedAt? : string | null;
  }





export class CurrencyMaster {
    description: string;     
    currencyId: string;  
}
export class User {
    Id: string;
    FullName: string;
    MobilePhone: string;
    EmailAddress: string;
    BirthDate: string;
    Gender: string;
    QID: string;
    Status: string;
    Active: string;
    Nationality: string;
    /** Contact type from token: 'Primary' | 'Secondary' (vendor portal) */
    ContactType: string;

    constructor({Id, FullName, MobilePhone, EmailAddress, BirthDate, Gender, QID, Status, Active, Nationality, ContactType}: 
                {Id?, FullName?, MobilePhone?, EmailAddress?, BirthDate?, Gender?, QID?, Status?, Active?, Nationality?, ContactType?}= {}) {
        this.Id = Id;
        this.FullName = FullName;
        this.MobilePhone = MobilePhone,
        this.EmailAddress = EmailAddress,
        this.BirthDate = BirthDate,
        this.Gender = Gender,
        this.QID = QID;
        this.Status = Status;
        this.Active = Active;
        this.Nationality = Nationality;
        this.ContactType = ContactType ?? 'Primary';
    }
}
export class RequestsDTO {
    items: Array<any>;
    totalCount: number;
}

export class ErrorDto {
    inputId: string;
    message: string;
}